import type { FacetComponentProps } from 'components/search/FacetAccordion/FacetAccordion.types';
import { cn } from 'helpers/classnames';
import { getTestId } from 'utils/testing';

export const ButtonFacet = (props: Extract<FacetComponentProps, { type: 'button' }>) => {
  const { label, count, isSelected, onClick, testId } = props;
  return (
    <button
      type="button"
      className={cn(
        'body-s-medium flex h-full w-full items-center justify-center rounded-sm border border-gray-300 px-2 py-2 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-900 focus-visible:ring-offset-2',
        { ['border-gray-900 bg-gray-900 text-gray-0 hover:bg-gray-900']: isSelected }
      )}
      onClick={onClick}
      aria-pressed={isSelected}
      data-test-id={getTestId(testId)}
    >
      <span>{label}</span>
      <span className="sr-only">{count} products available</span>
    </button>
  );
};
